const layoutTemplateUrl = require('../layout.html');

function authResolve(credentials) {
  return credentials.getCredentials().catch(() => null);
}

authResolve.$inject = ['ogsdk.credentials'];

function onEnter(analytics, tracking, config, merchantId, $state, auth) {
  if (!auth) {
    $state.go('notLoggedIn');
  }
  config.auth = auth;
  analytics.setChannel(merchantId, auth.sig_field);
  tracking.initTracking();
}

onEnter.$inject = ['analytics', 'tracking', 'config', 'merchantId', '$state', 'auth'];

module.exports = function($stateProvider) {
  $stateProvider.state('root', {
    templateUrl: layoutTemplateUrl,
    controller: 'LayoutController',
    controllerAs: '$ctrl',
    onEnter: onEnter,
    resolve: { auth: authResolve }
  });
};

module.exports.$inject = ['$stateProvider'];
